import React, { useEffect, createElement } from 'react';
import { ElegirPack } from './pages/ElegirPack';
const SITE_URL = 'https://bibliotecaprofesional.com/';
const SITE_TITLE = 'Biblioteca Profesional — MegaPacks digitales para profesionales y estudiantes';
const SITE_DESCRIPTION = 'Recursos digitales listos para usar: planes, sesiones, guías y actividades para Nutrición, Kinesiología, Estimulación Temprana, Psicología, Medicina y más.';
const SITE_KEYWORDS = 'biblioteca profesional, megapack, recursos digitales, nutrición, kinesiología, estimulación temprana, psicología, medicina, material clínico, planes de alimentación, guías de estudio';
const LCP_IMAGE = 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto:eco,dpr_auto,w_400/v1779676327/nutri-Photoroom_lqu1oy.png';
function setMeta(name: string, content: string, useProperty = false) {
  const attr = useProperty ? 'property' : 'name';
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
function setLink(rel: string, href: string, attrs: Record<string, string> = {}) {
  const key = `${rel}|${href}`;
  let el = document.head.querySelector<HTMLLinkElement>(`link[data-mp="${CSS.escape(key)}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('data-mp', key);
    el.rel = rel;
    el.href = href;
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el!.setAttribute(k, v));
}
function setJsonLd(id: string, data: unknown) {
  const existing = document.getElementById(id);
  if (existing) existing.remove();
  const script = document.createElement('script');
  script.id = id;
  script.type = 'application/ld+json';
  script.text = JSON.stringify(data);
  document.head.appendChild(script);
}
export function App() {
  useEffect(() => {
    // ---------- SEO ----------
    document.documentElement.lang = 'es';
    document.title = SITE_TITLE;
    setMeta('description', SITE_DESCRIPTION);
    setMeta('keywords', SITE_KEYWORDS);
    setMeta('robots', 'index, follow, max-image-preview:large');
    setMeta('viewport', 'width=device-width, initial-scale=1, viewport-fit=cover');
    setMeta('theme-color', '#F6F5F2');
    // Open Graph
    setMeta('og:title', SITE_TITLE, true);
    setMeta('og:description', SITE_DESCRIPTION, true);
    setMeta('og:type', 'website', true);
    setMeta('og:url', SITE_URL, true);
    setMeta('og:image', LCP_IMAGE, true);
    setMeta('og:locale', 'es_AR', true);
    setMeta('og:site_name', 'Biblioteca Profesional', true);
    // Twitter
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', SITE_TITLE);
    setMeta('twitter:description', SITE_DESCRIPTION);
    setMeta('twitter:image', LCP_IMAGE);
    // Canonical
    setLink('canonical', SITE_URL);
    // Structured data
    setJsonLd('mp-jsonld-itemlist', {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: SITE_TITLE,
      description: SITE_DESCRIPTION,
      url: SITE_URL,
      numberOfItems: 7,
      itemListElement: [{
        '@type': 'ListItem',
        position: 1,
        name: 'MegaPack Nutrición',
        url: 'https://nutripro.bibliotecaprofesional.com/'
      }, {
        '@type': 'ListItem',
        position: 2,
        name: 'MegaPack Kinesiología',
        url: 'https://kinesiologia.bibliotecaprofesional.com/'
      }, {
        '@type': 'ListItem',
        position: 3,
        name: 'MegaPack Estimulación Temprana',
        url: 'https://estimulacion.bibliotecaprofesional.com/'
      }, {
        '@type': 'ListItem',
        position: 4,
        name: 'MegaPack Carrera Nutrición',
        url: 'https://carreranutri.bibliotecaprofesional.com/'
      }, {
        '@type': 'ListItem',
        position: 5,
        name: 'MegaPack Carrera Kinesiología',
        url: 'https://carrerakine.bibliotecaprofesional.com/'
      }, {
        '@type': 'ListItem',
        position: 6,
        name: 'MegaPack Carrera Psicología',
        url: 'https://carrerapsico.bibliotecaprofesional.com/'
      }, {
        '@type': 'ListItem',
        position: 7,
        name: 'MegaPack Carrera Medicina',
        url: 'https://medicina.bibliotecaprofesional.com/'
      }]
    });
    setJsonLd('mp-jsonld-organization', {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Biblioteca Profesional',
      url: SITE_URL,
      logo: LCP_IMAGE,
      description: SITE_DESCRIPTION
    });
    // ---------- Performance ----------
    // Parallel DNS+TLS for the only remaining third-party origin (Cloudinary)
    setLink('preconnect', 'https://res.cloudinary.com', {
      crossorigin: ''
    });
    setLink('dns-prefetch', 'https://res.cloudinary.com');
    // Preload the LCP image so the browser fetches it before React commits
    setLink('preload', LCP_IMAGE, {
      as: 'image',
      fetchpriority: 'high'
    });
  }, []);
  return <ElegirPack data-id="element-0" />;
}